!((document, Drupal, $, once) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.marketShare = {
    attach: function (context) {
      $(once('market-share', 'html', context)).each(function () {
        // If you don't need jQuery:
        // 1. Remove the `jQuery` and `$` refrences from this file.
        // 2. Remove the `core/jquery` dependency from the marketShare library
        //    within the miax_global_pl.libraries.yml file.

        /* responsive check breakboints
        -------------------------------------------------------------------------*/

        var $mainHighChart = null;
        var EQUITIES_WEB_DOMAIN = '';

        // Constants
        var CHART_ID = '#miax-chart';
        var GET_SUMMARY_GROUP_DATA_PATH = 'indsum/summary_group';
        var GET_SUMMARY_DATA_PATH = 'indsum/summary';
        var PERCENTAGE_THRESHOLD = {
          options: [2, 2, 2, 1.5],
          equities: [2, 2, 2, 0.75]
        };
        var DOLLAR_SYMBOL_COLUMNS = ['TAPE_A_NOTIONAL_VALUE', 'TAPE_B_NOTIONAL_VALUE', 'TAPE_C_NOTIONAL_VALUE', 'EXCHANGE_NOTIONAL_VALUE', 'TAPE_A_AVERAGE_NOTIONAL_VALUE', 'TAPE_B_AVERAGE_NOTIONAL_VALUE', 'TAPE_C_AVERAGE_NOTIONAL_VALUE', 'EXCHANGE_AVERAGE_NOTIONAL_VALUE'];
        function IndSumChart(view) {
          var self = this;
          self.parentView = view;
          // Meta Data
          self.tid = undefined;
          self.exchType = undefined;
          self.sumType = undefined;
          self.busDate = undefined;
          // Variables
          self.defaultOptions = {
            chart: {
              backgroundColor: 'transparent',
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              renderTo: CHART_ID,
              marginLeft: 0,
              marginTop: 0,
              marginBottom: 0,
              height: null,
              type: 'pie',
              styledMode: true,
              spacingLeft: 0,
              events: {
                load: function() {
                  /* Code to execute after the initial chart load and render.
                  *
                  * Formerly the css class alterations were handled by self.setActiveExchangeClass(CHART_ID, exchType), but this doesn't work properly if styledMode (https://api.highcharts.com/highcharts/chart.styledMode)
                  * is enabled. Since the chart is initialized on a single element (CHART_ID or #miax-chart) applying it here ensures the pie chart finished loading before altering its styles.
                  * Otherwise, the CSS color changes will be visible instantly/prematurely, prior to other slower chart events (400ms animations etc.) completing.
                  */
                  jQuery(CHART_ID).removeClass('miax-branded').removeClass('miax-brand--equities').removeClass('miax-brand--options').addClass('miax-brand--' + self.exchType);
                  if (self.tid != 3) {
                    jQuery(CHART_ID).addClass('miax-branded');
                  }
                }
              }
            },
            title: false,
            colors: ['#2B2B2B', '#353535', '#404040', '#4F4F4F', '#5E5E5E', '#6B6B6B', '#757575'],
            tooltip: {
              enabled: true
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                animation: {
                  duration: 400,
                  easing: 'easeOutBounce'
                },
                borderColor: null,
                borderWidth: 1,
                cursor: 'pointer',
                dataLabels: {
                  align: 'left',
                  color: '#ffffff',
                  distance: -55,
                  shadow: false,
                  style: {
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textShadow: false,
                    textOutline: false,
                    textOverflow: 'none'
                  },
                  formatter: function () {
                    var threshold = PERCENTAGE_THRESHOLD[self.exchType][self.tid];
                    if (this.y > threshold) {
                      return this.point.name + '<br/>' + this.y.toFixed(2) + '%';
                    } else {
                      return '';
                    }
                  }
                },
                label: {
                  connectorAllowed: false
                },
                showInLegend: false,
                size: '100%',
                minSize: '100%',
                innerSize: '180px'
              }
            },
            credits: {
              enabled: false
            },
            responsive: {
              rules: [{
                condition: {
                  minWidth: 0,
                  maxWidth: 411
                },
                chartOptions: {
                  plotOptions: {
                    pie: {
                      innerSize: '25%'
                    }
                  }
                }
              }, {
                condition: {
                  minWidth: 412
                },
                chartOptions: {
                  plotOptions: {
                    pie: {
                      innerSize: '50%'
                    }
                  }
                }
              }]
            },
            series: [{
              name: 'Total',
              colorByPoint: true
            }]
          };
          self.chartOptions = undefined;
          self.data = undefined;

          // ======================== Init Methods ========================

          self.init = function (customOptions) {
            self.defaultOptions.tooltip = {
              formatter: self.toolTipFormatter
            };
            self.defaultOptions.series[0].point = {
              events: {
                click: self.pieClickHandler
              }
            };
            self.chartOptions = jQuery.extend(self.defaultOptions, customOptions);
          };

          // ======================= Getter Methods ==========================

          self.getData = function () {
            return self.data;
          };
          self.getId = function () {
            return CHART_ID;
          };

          // ===================== Utility Methods ===========================

          self.draw = function (tid, busDate, exchType, sumType) {
            // Set Properties
            self.tid = tid;
            self.busDate = busDate;
            self.exchType = exchType;
            self.sumType = sumType;
            // Set Url
            var url = self.buildGetChartDataUrl();
            // Get Chart Data
            jQuery.get(url).done(function (data) {
              self.data = data;
              var seriesData = self.tid === 3 ? self.data.map(el => [el[0], Number(el[1])]) : self.data.percentageData;
              // Set Options
              self.chartOptions.series[0].data = seriesData;
              // Draw Chart
              $mainHighChart = new Highcharts.Chart('miax-chart', self.chartOptions);
              // jQuery(CHART_ID).highcharts(self.chartOptions);
            }).fail(function (error) {
              throw error;
            });
          };
          self.buildGetChartDataUrl = function () {
            // Set Url
            var url = '/' + GET_SUMMARY_GROUP_DATA_PATH;
            if (self.tid === 3) {
              url = '/' + GET_SUMMARY_DATA_PATH;
            }
            url += '?tid=' + self.tid + '&exchType=' + self.exchType + '&date=' + self.busDate;
            if (self.exchType === 'equities') {
              url += '&sumType=' + self.sumType;
            }
            return url;
          };
          self.toolTipFormatter = function () {
            if (self.tid === 3) {
              return this.point.name + '<br/>Total: <strong>' + this.point.y.toFixed(2) + '%</strong>';
            }
            var tableData = self.parentView.getTable();
            var targetGroupProperties = ArrayUtility.findObjectByPropertyValue(self.data.exchangeGroups, 'name', this.key);
            var exchangeSummaryData = ArrayUtility.findObjectsByPropertyValues(tableData, 'EXCHANGE_DESCRIPTION', targetGroupProperties.exchanges);
            var toolTipContent = '';
            jQuery.each(exchangeSummaryData, function (index, data) {
              var colName = 'EQUITY_OPTION_TOTAL_PERCENTAGE';
              if (self.exchType === 'equities') {
                colName = self.sumType === 'volume' ? 'PERCENTAGE_OF_TOTAL_MARKET_TRADE_VOLUME' : 'PERCENTAGE_OF_TOTAL_MARKET_NOTIONAL_VALUE';
              }
              toolTipContent += '<br/><strong>' + data['EXCHANGE_DESCRIPTION'] + '</strong><br/>' + data[`${colName}`] + '%';
            });
            return toolTipContent;
          };

          // ================= Event Handler Methods ==========================

          self.pieClickHandler = function () {
            var ids = [];
            if (self.tid === 3) {
              ids.push(this.name);
            } else {
              var exchGrpProps = ArrayUtility.findObjectByPropertyValue(self.data.exchangeGroups, 'name', this.name);
              ids = ids.concat(exchGrpProps.exchanges);
            }
            var table = self.parentView.getTable();
            table.addClassToSummaryTableRowsByChartIds(ids, 'hovered');
            table.addClassToFullTableRowsByChartIds(ids, 'summary-table-highlighted-0');
            table.addClassToDetailPopupTableRowsByChartIds(ids, 'summary-table-highlighted-0');
          };
        }
        function IndSumView() {
          var self = this;
          // === Dependencies ===
          var chart = undefined;
          var table = undefined;
          // === Constants ===
          var GET_DATE_URL_PATH = 'indsum/getDate';
          var AUTO_REFRESH_IN_MS = drupalSettings.chart.autoRefresh ? drupalSettings.chart.autoRefresh * 1000 : 90000;
          var FOOTNOTE_TEXT = drupalSettings.chart.footnote_text;
          // === Variables ===
          // Flags
          var isInit = false;
          // Other
          var businessDate = undefined;
          var activeChartTabId = 0;
          var exchangeType = 'options';
          var summaryType = 'volume';
          var isDateChanged = false;
          var inViewport = false;
          self.hasScrollRefreshTriggered = true;

          // Initialization Methods

          self.init = function () {
            if (!isInit) {
              self.setDefaultExchType();
              self.setEventListeners();
              // self.initBusinessDateSelector();
              self.resetSummaryType();
              self.initChart();
              self.initTable();
              self.fetchBusinessDateAndRefresh();
              self.refreshAt();
              isInit = true;
              self.setTableToggleButtonLayout();
              self.setAutomaticRefresh();
              self.applyWindowResizeFuncs();
            }
          };

          // ======================== Init Methods ===========================

          self.initTable = function () {
            table = new IndSumTable(self);
            table.init();
          };
          self.initChart = function () {
            chart = new IndSumChart(self);
            chart.init({});
          };
          self.setTableToggleButtonLayout = function () {
            var minHeight = $('.c-chart__container').innerHeight();
            $('.c-chart__detail-view-btn').height(minHeight);
          };
          self.applyWindowResizeFuncs = function () {
            // Check if window resize and apply funcs that need to be adjusted
            window.onresize = function () {
              self.setTableToggleButtonLayout();
            };
          };
          self.initBusinessDateSelector = function () {
            jQuery('#datepicker').datepicker({
              changeMonth: true,
              changeYear: true,
              inline: true,
              autoSize: true,
              selectOtherMonths: true,
              keyboardNavigation: true,
              prevText: '<svg class="ui-datepicker-prev-icon" width="4" height="8">' + '<use xlink:href="/themes/custom/miax/img/icons/icons.svg#icon-arrow-left-small"></use></svg>',
              nextText: '<svg class="ui-datepicker-next-icon" width="4" height="8"><use xlink:href="/themes/custom/miax/img/icons/icons.svg#icon-arrow-right-small"></use></svg>',
              dateFormat: 'MM d, yy',
              maxDate: 0,
              beforeShowDay: jQuery.datepicker.noWeekends,
              onSelect: function () {
                var selectedDate = jQuery(this).datepicker('getDate');
                var formattedDateStr = jQuery.datepicker.formatDate('yy-mm-dd', selectedDate);
                self.setBusinessDate(formattedDateStr);
                jQuery.modal.close();
                isDateChanged = true;
              }
            });
          };

          // ======================= Setter Methods ==========================

          self.setDefaultExchType = function () {
            if (window.location.host === EQUITIES_WEB_DOMAIN) {
              exchangeType = 'equities';
              self.changeExchTypeSelection(exchangeType);
              jQuery('.c-tabs__assetclass div.c-glider').removeAttr('style').attr('style', 'left: 234px; width: 234px; visibility: visible;');
              self.toggleEquitiesFilterCriteria();
            }
          };

          // Check if element is in current viewport.
          self.inViewportCheck = function (element) {
            var elementTop = element.offset().top;
            var elementBottom = elementTop + element.outerHeight();
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
            return elementBottom > viewportTop && elementTop < viewportBottom;
          };
          self.setAutomaticRefresh = function () {
            // Set market opening and closing time.
            let currentStartTime = ' 08:00:00 EST';
            let currentEndTime = ' 18:00:00 EST';
            if (drupalSettings.chart.startTime) {
              currentStartTime = ' ' + drupalSettings.chart.startTime + ' EST';
            }
            if (drupalSettings.chart.endTime) {
              currentEndTime = ' ' + drupalSettings.chart.endTime + ' EST';
            }
            // Refresh chart on interval basis.
            window.setInterval(function () {
              // Check if the chart element is in current viewport.
              inViewport = self.inViewportCheck($('section.market-share'));
              // Calculate market start and end time with the current date.
              let now = new Date();
              let startTime = new Date(now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate() + currentStartTime);
              startTime = new Date(startTime.toLocaleString('en-US', {
                timeZone: 'EST'
              })).getTime();
              let endTime = new Date(now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate() + currentEndTime);
              endTime = new Date(endTime.toLocaleString('en-US', {
                timeZone: 'EST'
              })).getTime();
              // Calculate current time in EST.
              let timeNow = new Date(new Date().toLocaleString('en-US', {
                timeZone: 'America/New_York'
              })).getTime();
              if (!isDateChanged) {
                // Chart should be refreshed only during US market hours (EST)
                // and only if chart is in current viewport of the active tab.
                if (timeNow >= startTime && timeNow <= endTime && inViewport === true && !document.hidden) {
                  self.fetchBusinessDateAndRefresh();
                }
              } else {
                self.refresh();
              }
            }, AUTO_REFRESH_IN_MS);
          };
          self.setEventListeners = function () {
            jQuery('.form-group-toggle input').click(self.exchTypeChangedEventHandler);
            jQuery('.summary-type-selector input').change(self.summaryTypeChangedEventHandler);
            jQuery('.tabid-selector input').change(self.chartTabChangedEventHandler);
            jQuery('.date-picker input').change(function () {
              var dateVal = jQuery(this).val();
              if (dateVal) {
                isDateChanged = true;
                var formattedDateStr = moment(dateVal);
                self.setBusinessDate(formattedDateStr.format('YYYYMMDD'));
              } else {
                isDateChanged = false;
                self.fetchBusinessDateAndRefresh();
              }
            });
            jQuery(window).scroll(self.scrollHandler);
          };
          self.scrollFlipOn = function () {
            jQuery(window).scroll(self.scrollHandler);
          };
          self.scrollHandler = function () {
            var gbcr = jQuery('section.market-share')[0].getBoundingClientRect().top;
            if (gbcr < 250 && gbcr > -250) {
              if (!self.hasScrollRefreshTriggered) {
                self.hasScrollRefreshTriggered = true;
                self.refresh();
                setTimeout(self.scrollFlipOn, 2000);
              }
            } else {
              self.hasScrollRefreshTriggered = false;
            }
          };
          self.setExchangeType = function (type) {
            exchangeType = type;
            if (!isDateChanged) {
              self.fetchBusinessDateAndRefresh();
            } else {
              self.refresh();
            }
            self.toggleEquitiesFilterCriteria();
          };
          self.setBusinessDate = function (dateStr) {
            if (dateStr !== undefined && !isNaN(parseFloat(dateStr))) {
              businessDate = dateStr;
              // var momentDate = moment(dateStr, 'YYYY-MM-DD');
              // jQuery('.c-chart__date-text').html(momentDate.format('MMM D, YYYY'));
              self.refresh();
            } else {
              // Handle any cases where reading T_MARKET_VOLUME_DAILY_SUMMARY.BUSINESS_DATE
              // or T_EQUITY_MARKET_VOLUME_DAILY_SUMMARY.BUSINESS_DATE from the external DB may fail.
              businessDate = self.getMiaxWeekdate();
              self.refresh();
            }
          };

          // ======================= Getter Methods =========================

          self.getChart = function () {
            return chart;
          };
          self.getTable = function () {
            return table;
          };

          // ======================= Query Methods ==========================

          self.isEquities = function () {
            return exchangeType === 'equities';
          };

          // ===================== Utility Methods ==========================

          self.buildGetDateUrl = function () {
            // Set url
            var url = '/' + GET_DATE_URL_PATH;
            url += '?tid=' + activeChartTabId;
            url += '&exchType=' + exchangeType;
            if (self.isEquities()) {
              url += '&sumType=' + summaryType;
            }
            return url;
          };
          self.toggleEquitiesFilterCriteria = function () {
            var isVisible = exchangeType === 'equities';
            if (isVisible) {
              jQuery('.summary-type-selector').parent().show();
              $('#chart-graph .row').addClass('equities');
              if (summaryType === 'notional') {
                $('section.market-share').find('.footnote-text').addClass('show');
              }
            } else {
              jQuery('.summary-type-selector').parent().hide();
              $('#chart-graph .row').removeClass('equities');
              $('section.market-share').find('.footnote-text').removeClass('show');
            }
          };
          self.fetchBusinessDateAndRefresh = function () {
            var url = self.buildGetDateUrl();
            // Get Date
            jQuery.get(url).done(function (data) {
              // debugger;
              var busDateStr = businessDate;
              if (!isDateChanged) {
                busDateStr = data.date;
              }
              self.setBusinessDate(busDateStr);
            }).fail(function (error) {
              throw error;
            });
          };
          self.refresh = function () {
            // debugger;
            chart.draw(activeChartTabId, businessDate, exchangeType, summaryType);
            table.display(activeChartTabId, businessDate, exchangeType, summaryType);
          };

          // Refresh market chart at the beginning of the market open (9:30 AM).
          self.refreshAt = function () {
            var now = new Date();
            var timeRemaining = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 9, 30, 0, 0) - now;
            if (timeRemaining < 0) {
              timeRemaining += 86400000;
            }
            setTimeout(function () {
              self.refresh();
              self.refreshAt();
            }, timeRemaining);
          };
          self.resetSummaryType = function () {
            if ($('input[name=marketType]:checked', '.row-form').val()) {
              $('.summary-type-selector').parent().hide();
            }
          };
          self.isMiaxTradingHoliday = function (miaxdt) {
            var formattedMiaxHolidayArg = moment(miaxdt.toISOString()).format('YYYYMMDD');
            const holidays = ['20230102', '20230116', '20230219', '20230329', '20230527', '20230619', '20230704', '20230902', '20231123', '20231225', '20240101', '20240115', '20240219', '20240329', '20240527', '20240619', '20240704', '20240902', '20241128', '20241225', '20250101', '20250120', '20250217', '20250418', '20250526', '20250619', '20250704', '20250901', '20251127', '20251225'];
            if (holidays.includes(formattedMiaxHolidayArg)) {
              return true;
            }
            return false;
          };
          self.isMiaxBusinessDay = function (miaxdt) {
            var miaxWeekday = miaxdt.getDay();
            if (miaxWeekday == 0 || miaxWeekday == 6) {
              return false;
            }
            if (self.isMiaxTradingHoliday(miaxdt)) {
              return false;
            }
            return true;
          };
          self.getMiaxWeekdate = function () {
            var miaxWeekdate = new Date();
            while (!self.isMiaxBusinessDay(miaxWeekdate)) {
              miaxWeekdate.setDate(miaxWeekdate.getDate() - 1);
            }
            var formattedMiaxWeekdate = moment(miaxWeekdate.toISOString()).format('YYYYMMDD');
            return formattedMiaxWeekdate;
          };
          // ================= Event Handler Methods =========================

          self.exchTypeChangedEventHandler = function () {
            // evnt.preventDefault();
            var $this = jQuery(this);
            var exchType = $this.attr('data-exch-type');
            self.setExchangeType(exchType);
            self.changeExchTypeSelection(exchType);
          };
          self.changeExchTypeSelection = function (exchType) {
            var $this = jQuery('.c-tabs__exch-type a.c-tabs__link[data-exch-type="' + exchType + '"]');
            jQuery('.c-tabs__exch-type li').removeClass('is-active');
            $this.parent().addClass('is-active');
            var $tabs = $this.closest('.c-tabs.c-tabs__assetclass');
            $tabs.removeClass('c-tabs-open');
            $tabs.find('.c-tabs__nav-current').removeClass('c-tabs__nav-current-active').find('.c-tabs__nav-current-text').html($this.text());
          };
          self.summaryTypeChangedEventHandler = function () {
            summaryType = jQuery(this).val();
            self.refresh();
            if (summaryType == 'notional') {
              $('section.market-share').find('.footnote-text').text(FOOTNOTE_TEXT);
              $('section.market-share').find('.footnote-text').addClass('show');
            } else {
              $('section.market-share').find('.footnote-text').removeClass('show');
            }
          };
          self.chartTabChangedEventHandler = function () {
            /*evnt.preventDefault();
            var $this = jQuery(this);
            var thisTid = $this.data('tid');
            var $thisItem = $this.closest('.c-tabs__item');
            var $tabs = $this.closest('.c-tabs');
            if(! $thisItem.hasClass('is-active')) {
            jQuery('ul.c-chart__tabs .c-tabs__item').removeClass('is-active');
            $thisItem.addClass('is-active');
            $tabs.find('.c-tabs__nav-current').
            removeClass('c-tabs__nav-current-active').
            find('.c-tabs__nav-current-text').
            html($this.text());
            $tabs.removeClass('c-tabs-open');
            }
            activeChartTabId = thisTid;
            self.refresh();
            */
            activeChartTabId = parseInt(jQuery(this).val());
            self.refresh();
          };
        }
        function IndSumTable(view) {
          var self = this;
          self.parentView = view;
          // Meta Data
          self.tid = undefined;
          self.exchType = undefined;
          self.sumType = undefined;
          self.busDate = undefined;
          // Variables
          self.data = undefined;
          // Constants
          var GET_TABLE_DETAIL_PATH = 'indsum/detail';
          var SUMMARY_TABLE_ID = '#chart-data';
          var FULL_TABLE_ID = '#chart-data-full';
          var DETAIL_BUTTON_ID = '#chart-full-view';
          var DETAIL_POPUP_TABLE = '#chart-data-full-popup';
          var SUMMARY_TABLE_COLS = undefined;
          var FULL_TABLE_COLS = undefined;
          var SUMMARY_TABLE_ROW_ATTRS = undefined;
          var MIAX_EXCHANGES = [];

          // ======================== Init Methods =========================

          self.init = function () {
            SUMMARY_TABLE_COLS = {
              options: [[{
                name: 'EXCHANGE_DESCRIPTION',
                label: 'Exchange'
              }, {
                name: 'EQUITY_OPTION_TOTAL_VOLUME',
                label: 'Equity Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_TOTAL_PERCENTAGE',
                label: 'EQUITY TOTAL %',
                formatter: self.percentageFormatter
              }, {
                name: 'OPTION_TOTAL_VOLUME',
                label: 'Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'OPTION_TOTAL_PERCENTAGE',
                label: 'TOTAL %',
                formatter: self.percentageFormatter
              }], [{
                name: 'EXCHANGE_DESCRIPTION',
                label: 'Exchange'
              }, {
                name: 'EQUITY_OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Equity Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_TOTAL_PERCENTAGE',
                label: 'EQUITY TOTAL %',
                formatter: self.percentageFormatter
              }, {
                name: 'OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'OPTION_TOTAL_PERCENTAGE',
                label: 'TOTAL %',
                formatter: self.percentageFormatter
              }], [{
                name: 'EXCHANGE_DESCRIPTION',
                label: 'Exchange'
              }, {
                name: 'EQUITY_OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Equity Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_TOTAL_PERCENTAGE',
                label: 'EQUITY TOTAL %',
                formatter: self.percentageFormatter
              }, {
                name: 'OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'OPTION_TOTAL_PERCENTAGE',
                label: 'TOTAL %',
                formatter: self.percentageFormatter
              }], [{
                name: 'SECURITY_SYMBOL',
                label: 'Symbol'
              }, {
                name: 'PERCENTAGE_OF_TOTAL_OPTION_VOLUME',
                label: 'Industry Total Volume %',
                formatter: self.percentageFormatter
              }, {
                name: 'MIAX_MARKET_SHARE',
                label: 'MIAX <br/>Options <br/>%',
                formatter: self.percentageFormatter
              }, {
                name: 'PEARL_MARKET_SHARE',
                label: 'MIAX <br/>PEARL <br/>%',
                formatter: self.percentageFormatter
              }, {
                name: 'EMERALD_MARKET_SHARE',
                label: 'MIAX <br/>EMERALD <br/>%',
                formatter: self.percentageFormatter
              }, {
                name: 'SAPPHIRE_MARKET_SHARE',
                label: 'MIAX <br/>SAPPHIRE <br/>%',
                formatter: self.percentageFormatter
              }]],
              equities: {
                volume: [[{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'EXCHANGE_TRADE_VOLUME',
                  label: 'EXCHANGE MARKET VOLUME',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_TRADE_VOLUME',
                  label: 'EXCHANGE MARKET VOLUME %',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'EXCHANGE_AVERAGE_TRADE_VOLUME',
                  label: 'EXCHANGE MARKET VOLUME',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_TRADE_VOLUME',
                  label: 'EXCHANGE MARKET VOLUME %',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'EXCHANGE_AVERAGE_TRADE_VOLUME',
                  label: 'EXCHANGE MARKET VOLUME',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_TRADE_VOLUME',
                  label: 'EXCHANGE MARKET VOLUME %',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'TICKER_SYMBOL',
                  label: 'Symbol'
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_TRADE_VOLUME',
                  label: 'Market Volume %',
                  formatter: self.percentageFormatter
                }, {
                  name: 'PEARL_PERCENTAGE_TRADE_VOLUME',
                  label: 'MIAX <br/>PEARL<br/>%',
                  formatter: self.percentageFormatter
                }]],
                notional: [[{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'EXCHANGE_NOTIONAL_VALUE',
                  label: 'Notional Value Traded ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_NOTIONAL_VALUE',
                  label: 'Industry Notional Value Traded (%)',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'EXCHANGE_AVERAGE_NOTIONAL_VALUE',
                  label: 'Notional Value Traded ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_NOTIONAL_VALUE',
                  label: 'Industry Notional Value Traded (%)',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'EXCHANGE_AVERAGE_NOTIONAL_VALUE',
                  label: 'Notional Value Traded ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_NOTIONAL_VALUE',
                  label: 'Industry Notional Value Traded (%)',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'TICKER_SYMBOL',
                  label: 'Symbol'
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_NOTIONAL_VALUE',
                  label: 'Market Volume %',
                  formatter: self.percentageFormatter
                }, {
                  name: 'PEARL_PERCENTAGE_NOTIONAL_VALUE',
                  label: 'MIAX <br/>PEARL<br/>%',
                  formatter: self.percentageFormatter
                }]]
              }
            };
            FULL_TABLE_COLS = {
              options: [[{
                name: 'EXCHANGE_DESCRIPTION',
                label: 'Exchange'
              }, {
                name: 'EQUITY_OPTION_CALL_VOLUME',
                label: 'Equity Call Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_PUT_VOLUME',
                label: 'Equity Put Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_TOTAL_VOLUME',
                label: 'Equity Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_TOTAL_PERCENTAGE',
                label: 'Equity Total %',
                formatter: self.percentageFormatter
              }, {
                name: 'INDEX_OPTION_TOTAL_VOLUME',
                label: 'Index Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'INDEX_OPTION_TOTAL_PERCENTAGE',
                label: 'Index Total %',
                formatter: self.percentageFormatter
              }, {
                name: 'OPTION_TOTAL_VOLUME',
                label: 'Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'OPTION_TOTAL_PERCENTAGE',
                label: 'Total %',
                formatter: self.percentageFormatter
              }], [{
                name: 'EXCHANGE_DESCRIPTION',
                label: 'Exchange'
              }, {
                name: 'EQUITY_OPTION_CALL_AVERAGE_VOLUME',
                label: 'Equity Call Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_PUT_AVERAGE_VOLUME',
                label: 'Equity Put Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Equity Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_TOTAL_PERCENTAGE',
                label: 'Equity Total %',
                formatter: self.percentageFormatter
              }, {
                name: 'INDEX_OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Index Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'INDEX_OPTION_TOTAL_PERCENTAGE',
                label: 'Index Total %',
                formatter: self.percentageFormatter
              }, {
                name: 'OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'OPTION_TOTAL_PERCENTAGE',
                label: 'Total %',
                formatter: self.percentageFormatter
              }], [{
                name: 'EXCHANGE_DESCRIPTION',
                label: 'Exchange'
              }, {
                name: 'EQUITY_OPTION_CALL_AVERAGE_VOLUME',
                label: 'Equity Call Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_PUT_AVERAGE_VOLUME',
                label: 'Equity Put Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Equity Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'EQUITY_OPTION_TOTAL_PERCENTAGE',
                label: 'Equity Total %',
                formatter: self.percentageFormatter
              }, {
                name: 'INDEX_OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Index Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'INDEX_OPTION_TOTAL_PERCENTAGE',
                label: 'Index Total %',
                formatter: self.percentageFormatter
              }, {
                name: 'OPTION_TOTAL_AVERAGE_VOLUME',
                label: 'Total Volume',
                formatter: self.numberFormatter
              }, {
                name: 'OPTION_TOTAL_PERCENTAGE',
                label: 'Total %',
                formatter: self.percentageFormatter
              }], [{
                name: 'SECURITY_SYMBOL',
                label: 'Symbol'
              }, {
                name: 'CALL_VOLUME',
                label: 'Industry Call Volume',
                formatter: self.numberFormatter
              }, {
                name: 'PUT_VOLUME',
                label: 'Industry Put Volume',
                formatter: self.numberFormatter
              }, {
                name: 'TOTAL_VOLUME',
                label: 'Total Option Volume',
                formatter: self.numberFormatter
              }, {
                name: 'PERCENTAGE_OF_TOTAL_OPTION_VOLUME',
                label: 'Industry Total Volume %',
                formatter: self.percentageFormatter
              }, {
                name: 'MIAX_MARKET_SHARE',
                label: 'MIAX <br/>Options <br/>%',
                formatter: self.percentageFormatter
              }, {
                name: 'PEARL_MARKET_SHARE',
                label: 'MIAX <br/>PEARL <br/>%',
                formatter: self.percentageFormatter
              }, {
                name: 'EMERALD_MARKET_SHARE',
                label: 'MIAX <br/>EMERALD <br/>%',
                formatter: self.percentageFormatter
              }, {
                name: 'SAPPHIRE_MARKET_SHARE',
                label: 'MIAX <br/>SAPPHIRE <br/>%',
                formatter: self.percentageFormatter
              }]],
              equities: {
                volume: [[{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'TAPE_A_TRADE_VOLUME',
                  label: 'Tape A Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_B_TRADE_VOLUME',
                  label: 'Tape B Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_C_TRADE_VOLUME',
                  label: 'Tape C Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'EXCHANGE_TRADE_VOLUME',
                  label: 'Exchange Market Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_TRADE_VOLUME',
                  label: 'Total Market Volume %',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'TAPE_A_AVERAGE_TRADE_VOLUME',
                  label: 'Tape A Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_B_AVERAGE_TRADE_VOLUME',
                  label: 'Tape B Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_C_AVERAGE_TRADE_VOLUME',
                  label: 'Tape C Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'EXCHANGE_AVERAGE_TRADE_VOLUME',
                  label: 'Exchange Market Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_TRADE_VOLUME',
                  label: 'Total Market Volume %',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'TAPE_A_AVERAGE_TRADE_VOLUME',
                  label: 'Tape A Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_B_AVERAGE_TRADE_VOLUME',
                  label: 'Tape B Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_C_AVERAGE_TRADE_VOLUME',
                  label: 'Tape C Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'EXCHANGE_AVERAGE_TRADE_VOLUME',
                  label: 'Exchange Market Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_TRADE_VOLUME',
                  label: 'Total Market Volume %',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'TICKER_SYMBOL',
                  label: 'Symbol'
                }, {
                  name: 'TRADE_VOLUME',
                  label: 'Trade Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'TOTAL_MARKET_TRADE_VOLUME',
                  label: 'Total Market Volume',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_TRADE_VOLUME',
                  label: 'Total Market Volume %',
                  formatter: self.percentageFormatter
                }, {
                  name: 'PEARL_PERCENTAGE_TRADE_VOLUME',
                  label: 'PEARL Market Volume %',
                  formatter: self.percentageFormatter
                }]],
                notional: [[{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'TAPE_A_NOTIONAL_VALUE',
                  label: 'Tape A Notional Volume ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_B_NOTIONAL_VALUE',
                  label: 'Tape B Notional Volume ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_C_NOTIONAL_VALUE',
                  label: 'Tape C Notional Volume ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'EXCHANGE_NOTIONAL_VALUE',
                  label: 'Notional Value Traded ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_NOTIONAL_VALUE',
                  label: 'Industry Notional Value Traded (%)',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'TAPE_A_AVERAGE_NOTIONAL_VALUE',
                  label: 'Tape A Notional Volume ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_B_AVERAGE_NOTIONAL_VALUE',
                  label: 'Tape B Notional Volume ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_C_AVERAGE_NOTIONAL_VALUE',
                  label: 'Tape C Notional Volume ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'EXCHANGE_AVERAGE_NOTIONAL_VALUE',
                  label: 'Notional Value Traded ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_NOTIONAL_VALUE',
                  label: 'Industry Notional Value Traded (%)',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'EXCHANGE_DESCRIPTION',
                  label: 'Exchange'
                }, {
                  name: 'TAPE_A_AVERAGE_NOTIONAL_VALUE',
                  label: 'Tape A Notional Volume ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_B_AVERAGE_NOTIONAL_VALUE',
                  label: 'Tape B Notional Volume ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'TAPE_C_AVERAGE_NOTIONAL_VALUE',
                  label: 'Tape C Notional Volume ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'EXCHANGE_AVERAGE_NOTIONAL_VALUE',
                  label: 'Notional Value Traded ($)',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_NOTIONAL_VALUE',
                  label: 'Industry Notional Value Traded (%)',
                  formatter: self.percentageFormatter
                }], [{
                  name: 'TICKER_SYMBOL',
                  label: 'Symbol'
                }, {
                  name: 'NOTIONAL_VALUE',
                  label: 'Notional Value',
                  formatter: self.numberFormatter
                }, {
                  name: 'TOTAL_MARKET_NOTIONAL_VALUE',
                  label: 'Total Market Notional Value',
                  formatter: self.numberFormatter
                }, {
                  name: 'PERCENTAGE_OF_TOTAL_MARKET_NOTIONAL_VALUE',
                  label: 'Notional Value % of Total',
                  formatter: self.percentageFormatter
                }, {
                  name: 'PEARL_PERCENTAGE_NOTIONAL_VALUE',
                  label: 'PEARL Notional Value %',
                  formatter: self.percentageFormatter
                }]]
              }
            };
            SUMMARY_TABLE_ROW_ATTRS = {
              options: ['data-hover-chart="{{EXCHANGE_DESCRIPTION}}" data-exchange="{{EXCHANGE_DESCRIPTION}}"', 'data-hover-chart="{{EXCHANGE_DESCRIPTION}}" data-exchange="{{EXCHANGE_DESCRIPTION}}"', 'data-hover-chart="{{EXCHANGE_DESCRIPTION}}" data-exchange="{{EXCHANGE_DESCRIPTION}}"', 'data-hover-chart="{{SECURITY_SYMBOL}}" data-exchange="{{SECURITY_SYMBOL}}"', 'data-hover-chart="{{EXCHANGE_DESCRIPTION}}" data-exchange="{{EXCHANGE_DESCRIPTION}}"', 'data-hover-chart="{{SECURITY_SYMBOL}}" data-exchange="{{SECURITY_SYMBOL}}"'],
              equities: ['data-hover-chart="{{EXCHANGE_DESCRIPTION}}" data-exchange="{{EXCHANGE_DESCRIPTION}}"', 'data-hover-chart="{{EXCHANGE_DESCRIPTION}}" data-exchange="{{EXCHANGE_DESCRIPTION}}"', 'data-hover-chart="{{EXCHANGE_DESCRIPTION}}" data-exchange="{{EXCHANGE_DESCRIPTION}}"', 'data-hover-chart="{{TICKER_SYMBOL}}" data-exchange="{{TICKER_SYMBOL}}"']
            };
            jQuery(document).on('mouseenter touchstart', '[data-hover-chart]', self.hoverOverRowHandler);
          };

          // ======================= Setter Methods =======================

          self.addClassToSummaryTableRowsByChartIds = function (chartIds, className) {
            self.addClassToTableRowsByChartIds(chartIds, SUMMARY_TABLE_ID, className);
          };
          self.addClassToFullTableRowsByChartIds = function (chartIds, className) {
            self.addClassToTableRowsByChartIds(chartIds, FULL_TABLE_ID, className);
          };
          self.addClassToDetailPopupTableRowsByChartIds = function (chartIds, className) {
            self.addClassToTableRowsByChartIds(chartIds, DETAIL_POPUP_TABLE, className);
          };
          self.addClassToTableRowsByChartIds = function (chartIds, tableId, className) {
            jQuery(tableId + ' div[data-hover-chart]').removeClass(className);
            chartIds.forEach(function (chartId) {
              jQuery(tableId).find('[data-hover-chart^="' + chartId + '"]').addClass(className);
            });
          };

          // ======================= Getter Methods =========================

          self.getTableHeadersAsHtml = function (cols, type = 'summary') {
            var html = '<div tabindex="0" id="c-chart__table-' + type + '-thead-row" class="c-chart__table-row">';
            cols.forEach(function (col) {
              html += '<div class="c-chart__table-cell c-chart__table-cell-head"><span class="c-chart__table-text"></span>' + col.label + '</div>';
            });
            html += '</div>';
            return html;
          };
          self.getData = function () {
            // return self.data;
            return [];
          };
          self.getSummaryTableId = function () {
            return SUMMARY_TABLE_ID;
          };

          // ===================== Utility Methods ==========================

          self.setActiveExchangeClass = function (element_id, exchType) {
            $(element_id).removeClass('miax-brand--equities').removeClass('miax-brand--options').addClass('miax-brand--' + exchType);
          };

          self.display = function (tid, busDate, exchType, sumType) {
            // Set Properties
            self.tid = tid;
            self.busDate = busDate;
            self.exchType = exchType;
            self.sumType = sumType;
            // Print Summary Table Header
            var cols = exchType === 'options' ? SUMMARY_TABLE_COLS[exchType][tid] : SUMMARY_TABLE_COLS[exchType][sumType][tid];
            var html = self.getTableHeadersAsHtml(cols);

            jQuery(SUMMARY_TABLE_ID).html(html);

            // Print Full Table Header
            cols = exchType === 'options' ? FULL_TABLE_COLS[exchType][tid] : FULL_TABLE_COLS[exchType][sumType][tid];
            html = self.getTableHeadersAsHtml(cols, 'full');
            jQuery(FULL_TABLE_ID).html(html);
            jQuery(DETAIL_POPUP_TABLE).html(html);
            // Print Table Data
            self.printTableData();

            // Set class for styling.
            self.setActiveExchangeClass(SUMMARY_TABLE_ID, exchType);
            self.setActiveExchangeClass(FULL_TABLE_ID, exchType);
            self.setActiveExchangeClass(DETAIL_BUTTON_ID, exchType);
          };
          self.printTableData = function () {
            var url = self.buildGetTableDataUrl();
            jQuery.get(url).done(function (data) {
              // During this callback for a successful ajax response, unless the table is emptied, a duplicate response of data rows can be appended to SUMMARY_TABLE_ID and FULL_TABLE_ID.

              // Empty summary table except for heading.
              var $thead = jQuery(SUMMARY_TABLE_ID).find('#c-chart__table-summary-thead-row');
              jQuery(SUMMARY_TABLE_ID).html($thead);

              // Empty full table except for heading.
              var $thead = jQuery(FULL_TABLE_ID).find('#c-chart__table-full-thead-row');
              jQuery(FULL_TABLE_ID).html($thead);

              self.prepareData(data);
              self.data = data;
              // Print Summary Table Data
              var cols = self.exchType === 'options' ? SUMMARY_TABLE_COLS[self.exchType][self.tid] : SUMMARY_TABLE_COLS[self.exchType][self.sumType][self.tid];
              var attrs = SUMMARY_TABLE_ROW_ATTRS[self.exchType][self.tid];
              self.buildTableDataHtmlAndAppend(cols, SUMMARY_TABLE_ID, attrs);
              // Print Full Table Data
              cols = self.exchType === 'options' ? FULL_TABLE_COLS[self.exchType][self.tid] : FULL_TABLE_COLS[self.exchType][self.sumType][self.tid];
              self.buildTableDataHtmlAndAppend(cols, FULL_TABLE_ID, attrs);
              // Print Detail Popup Data
              self.buildTableDataHtmlAndAppend(cols, DETAIL_POPUP_TABLE, attrs);
              // Show Date
              self.displayAsOfDate();
              // Get MIAX Group Exchanges for highlighting
              self.data.forEach(function (row) {
                if (row.EXCHANGE_GROUP == 'MIAX') {
                  MIAX_EXCHANGES.push(row.EXCHANGE_DESCRIPTION);
                }
                ;
              });
              self.highlightRowsByExchanges(MIAX_EXCHANGES);
            }).fail(function (error) {
              throw error;
            });
          };
          self.prepareData = function (data) {
            if (self.exchType === 'equities' && self.tid !== 3) {
              ArrayUtility.findObjByPropValueAndMoveInArray(data, 'EXCHANGE_DESCRIPTION', 'TRF (DB,DN,DT)', -1);
            }
          };
          self.buildTableDataHtmlAndAppend = function (cols, tableId, attrs) {
            var firstRow = self.data[0][0];
            self.data.forEach(function (row) {
              var attributes = attrs !== undefined ? attrs : '';
              var html = '<div tabindex="0" class="c-chart__table-row" ' + attributes + '>';
              cols.forEach(function (col) {
                var value = row[col.name];
                html = self.replaceAll(html, col.name, value);
                var formattedValue = col.formatter ? col.formatter(value) : value;
                if (self.sumType == 'notional' && (row[0] == 'TOTAL' || row[0] === firstRow) && jQuery.inArray(col.name, DOLLAR_SYMBOL_COLUMNS) != -1) {
                  html += '<div class="c-chart__table-cell"><span class="c-chart__table-text">$' + formattedValue + '</span></div>';
                } else {
                  html += '<div class="c-chart__table-cell"><span class="c-chart__table-text">' + formattedValue + '</span></div>';
                }
              });
              html += '</div>';
              jQuery(tableId).append(html);
            });
          };
          self.replaceAll = function (template, trgStr, newStr) {
            var re = new RegExp('{{' + trgStr + '}}', 'gi');
            return template.replace(re, function () {
              return newStr;
            });
          };
          self.buildGetTableDataUrl = function () {
            // Set Url
            var url = '/' + GET_TABLE_DETAIL_PATH;
            url += '?tid=' + self.tid + '&exchType=' + self.exchType + '&date=' + self.busDate;
            if (self.exchType === 'equities') {
              url += '&sumType=' + self.sumType;
            }
            return url;
          };
          self.percentageFormatter = function (value) {
            return value + ' %';
          };
          self.numberFormatter = function (value) {
            return parseInt(value).toLocaleString('en-US', {});
          };
          self.hoverOverRowHandler = function () {
            jQuery('[data-hover-chart]').removeClass('hovered');
            jQuery(this).addClass('hovered');
            var dataPiece = undefined;
            var exchangeName = jQuery(this).data('hover-chart');
            if (self.tid === 3) {
              dataPiece = StringUtility.getFirstWord(exchangeName);
              dataPiece = dataPiece.trim();
            } else {
              dataPiece = self.getExchangeGroupNameByExchangeName(exchangeName);
            }
            // var chartId = self.parentView.getChart().getId();
            // var $mainHighChart = jQuery(chartId).highcharts();
            $mainHighChart.series[0].data.forEach(function (item) {
              if (item.name.trim() === dataPiece) {
                item.select(true, false);
                $mainHighChart.tooltip.refresh(item);
              }
            });
          };
          self.getExchangeGroupNameByExchangeName = function (exchangeName) {
            var exchangeGroupName = undefined;
            var chartData = self.parentView.getChart().getData();
            jQuery.each(chartData.exchangeGroups, function (index, groupProperties) {
              if (groupProperties.exchanges.indexOf(exchangeName) >= 0) {
                exchangeGroupName = groupProperties.name;
                return false;
              }
            });
            return exchangeGroupName;
          };
          self.highlightRowsByExchanges = function (exchanges) {
            if (self.tid !== 3) {
              self.addClassToSummaryTableRowsByChartIds(exchanges, 'summary-table-highlighted-3');
              self.addClassToFullTableRowsByChartIds(exchanges, 'summary-table-highlighted-3');
              self.addClassToDetailPopupTableRowsByChartIds(exchanges, 'summary-table-highlighted-3');
            }
          };
          self.getFormattedDate = function (date) {
            var dateAr = date.split('/');
            var formatted = dateAr[1] + '/' + dateAr[0].slice(-2) + '/' + dateAr[2];
            return formatted;
          };
          self.displayAsOfDate = function () {
            // Sometimes comes back as empty arr
            if (self.data.length > 0) {
              if (self.tid === 0) {
                jQuery('#data-as-of-date').html('Data as of ' + self.data[0].DATA_DATE);
              } else if (self.tid === 1) {
                jQuery('#data-as-of-date').html('Data as of ' + self.getFormattedDate(self.data[0].DATA_START_DATE) + ' - ' + self.getFormattedDate(self.data[0].DATA_END_DATE));
              } else if (self.tid === 2) {
                jQuery('#data-as-of-date').html('Data as of ' + self.getFormattedDate(self.data[0].DATA_START_DATE) + ' - ' + self.getFormattedDate(self.data[0].DATA_END_DATE));
              } else if (self.tid === 3) {
                var time = self.data[0].DATA_DATE + ' UTC';
                var timeZone = [new Date(time)];
                var estTimezone = timeZone.toLocaleString('en-US', {
                  timeZone: 'EST',
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit'
                });
                jQuery('#data-as-of-date').html('Data as of ' + estTimezone);
              }
            }
          };
        }

        var ArrayUtility = {
          /**
           * Returns object by property from array objects
           * @param {Array} objArr : Object array
           * @param {string} propertyName : Target object's property name
           * @param {string} propertyValue : Target object's property value
           * @returns {object} object
           */
          findObjectByPropertyValue: function (objArr, propertyName, propertyValue) {
            var retObj = {};
            jQuery.each(objArr, function (index, object) {
              if (object[propertyName] === propertyValue) {
                retObj = object;
                return false;
              }
            });
            return retObj;
          },
          getObjIndexByPropValue: function (objArr, propertyName, propertyValue) {
            var retIndex = -1;
            jQuery.each(objArr, function (index, object) {
              if (object[propertyName] === propertyValue) {
                retIndex = index;
                return false;
              }
            });
            return retIndex;
          },
          /**
           * Returning the Array.
           *
           * @param {Array} objArr : Object Array
           * @param {string} propertyName : Object property name
           * @param {string} propertyValues : Object property Value
           * @returns {Array} {{}} Array Value
           */
          findObjectsByPropertyValues: function (objArr, propertyName, propertyValues) {
            var retArr = [];
            jQuery.each(objArr.data, function (index, object) {
              if (propertyValues.indexOf(object[propertyName]) >= 0) {
                retArr.push(object);
              }
            });
            return retArr;
          },
          findObjByPropValueAndMoveInArray: function (objArr, propName, propVal, trgIndex) {
            var srcIndex = ArrayUtility.getObjIndexByPropValue(objArr, propName, propVal);
            var destIndex = trgIndex >= 0 ? trgIndex : objArr.length + trgIndex - 1;
            if (srcIndex >= 0 && srcIndex !== destIndex && destIndex >= 0 && destIndex < objArr.length) {
              var trgElement = objArr.splice(srcIndex, 1)[0];
              objArr.splice(destIndex, 0, trgElement);
            }
          }
        };
        var StringUtility = {
          containsStr: function (haystack, needle) {
            if (!_.isString(haystack) || !_.isString(needle)) {
              throw Error('Given values are not string');
            }
            return haystack.indexOf(needle) !== -1;
          },
          getDateRangeDiffUnit: function (diffStr) {
            if (StringUtility.containsStr(diffStr, 'year')) {
              return 'year';
            } else if (StringUtility.containsStr(diffStr, 'month')) {
              return 'month';
            } else if (StringUtility.containsStr(diffStr, 'day')) {
              return 'day';
            } else if (StringUtility.containsStr(diffStr, 'hour')) {
              return 'hour';
            } else if (StringUtility.containsStr(diffStr, 'minute')) {
              return 'minute';
            } else if (StringUtility.containsStr(diffStr, 'second')) {
              return 'second';
            }
          },
          getFirstWord: function (str) {
            if (str.indexOf(' ') === -1) {
              return str;
            } else {
              return str.substr(0, str.indexOf(' '));
            }
          },
          isEmpty: function (str) {
            return str === undefined || str === '';
          }
        };

        /* chart change view mobile
        -----------------------------------------------------------------------*/

        if (jQuery('.c-chart').length) {
          //TODO: Change base url
          //var chartMiax = new ChartMiax('https://'+window.location.host+'/indsum/');
          //var chartMiax = new ChartMiax('/indsum/');
          var indSumView = new IndSumView();
          indSumView.init();
        }

        /* chart change view mobile
        ------------------------------------------------------------------------*/
        jQuery(document).on('click', '.c-chart__view-tabs-link', function (e) {
          e.preventDefault();
          var $this = jQuery(this);
          var $item = $this.closest('.c-chart__view-tabs-item');
          var activeTab = $this.attr('href');
          if (!$item.hasClass('c-chart__view-tabs-item-active')) {
            $item.addClass('c-chart__view-tabs-item-active').siblings().removeClass('c-chart__view-tabs-item-active');
            jQuery('.c-chart__view-tab').removeClass('c-chart__view-tab-visible');
            jQuery(activeTab).addClass('c-chart__view-tab-visible');
          }
          // var chart = jQuery('#miax-chart').highcharts();
          $mainHighChart.reflow();
        });
        jQuery(document).on('click', '.c-chart__detail-view-btn', function (e) {
          e.preventDefault();
          var $this = jQuery(this);
          var closeText = $this.data('close-text');
          var openText = $this.data('open-text');
          var $textWrap = $this.find('.c-chart__detail-view-btn-text');
          if ($this.hasClass('active')) {
            $this.removeClass('active');
            $textWrap.html(openText);
            jQuery('.c-chart__view-slide').removeClass('c-chart__view-slide-move');

            // if(isBreakpoint('md') || isBreakpoint('lg')){
            jQuery('.c-chart__full-view').removeClass('bounceInLeft').addClass('bounceInRight');
            // }
          } else {
            $this.addClass('active');
            $textWrap.html(closeText);
            jQuery('.c-chart__view-slide').addClass('c-chart__view-slide-move');
            // if(isBreakpoint('md') || isBreakpoint('lg')){
            jQuery('.c-chart__full-view').removeClass('bounceInRight').addClass('bounceInLeft');
            // }
          }
        });
        jQuery(document).on('click', '.l-sidebar__nav-current-link', function (e) {
          e.preventDefault();
          var $this = jQuery(this);
          var thisText = $this.text();
          var $nav = $this.closest('.l-sidebar__nav');
          var $currentTextContainer = $nav.find('.l-sidebar__nav-current-text');
          $this.toggleClass('active');
          $nav.toggleClass('l-sidebar__nav-open');
          $currentTextContainer.html(thisText);
        });
      });
    }
  };
})(document, Drupal, jQuery, once);
//# sourceMappingURL=market-share.js.map
